module.exports = __webpack_public_path__ + "img/analysis.9d402081.svg";